import { useEffect, useState } from "react";
import { BookOpenCheck } from "lucide-react";
import { api, fmtMoney } from "@/lib/api";
import { inputCls } from "@/components/kit";

export const DISCOUNT_TYPES = ["Percentuale (%)", "Importo fisso (€)"];

export function discountOf(gross, tipo, valore) {
  const v = Number(valore || 0);
  if (!tipo || v <= 0) return 0;
  const s = tipo.startsWith("Percent") ? (gross * v) / 100 : v;
  return Math.round(Math.min(Math.max(s, 0), gross) * 100) / 100;
}

export function DiscountFields({ data, setData, disabled, gross }) {
  const sc = discountOf(gross, data.sconto_tipo, data.sconto_valore);
  return (
    <div className="rounded-lg border border-dashed border-[#34B3B0] p-4 space-y-3" data-testid="discount-fields">
      <div className="text-xs font-medium text-[#47606B]">Sconto (compare su PDF e contratto solo se applicato)</div>
      <div className="grid sm:grid-cols-3 gap-3">
        <select className={inputCls} disabled={disabled} value={data.sconto_tipo || ""} onChange={(e) => setData("sconto_tipo", e.target.value)} data-testid="discount-type">
          <option value="">Nessuno sconto</option>
          {DISCOUNT_TYPES.map((t) => <option key={t}>{t}</option>)}
        </select>
        {data.sconto_tipo && <input type="number" min={0} className={inputCls} disabled={disabled} value={data.sconto_valore || ""} onChange={(e) => setData("sconto_valore", e.target.value)} placeholder={data.sconto_tipo.startsWith("Percent") ? "es. 10" : "es. 500"} data-testid="discount-value" />}
        {data.sconto_tipo && <input className={inputCls} disabled={disabled} value={data.sconto_motivo || ""} onChange={(e) => setData("sconto_motivo", e.target.value)} placeholder="Motivo (facoltativo)" data-testid="discount-reason" />}
      </div>
      {sc > 0 && <div className="text-xs text-[#166534]" data-testid="discount-amount">Sconto applicato: - {fmtMoney(sc)}</div>}
    </div>
  );
}

export function PresetPicker({ evento, onApply }) {
  const [list, setList] = useState([]);
  useEffect(() => {
    api.get("/menu-presets").then((r) => setList(r.data.filter((p) => p.attivo !== false))).catch(() => {});
  }, []);
  const shown = list.filter((p) => !(p.evento_tipi || []).length || p.evento_tipi.includes(evento));
  if (!shown.length) return <div className="text-xs text-[#7B929C]">Suggerimento: crea i tuoi menù preimpostati in «Listino → Menù preimpostati» e caricali qui con un tocco.</div>;
  return (
    <div className="flex flex-wrap gap-2 items-center" data-testid="preset-picker">
      <span className="text-xs text-[#7B929C] inline-flex items-center gap-1"><BookOpenCheck size={13} /> Carica un menù preimpostato:</span>
      {shown.map((p) => (
        <button key={p.id} onClick={() => onApply(p)} data-testid={`preset-pick-${p.id}`} className="text-xs px-3 py-1.5 rounded-full border border-[#0B6E8F]/40 bg-[#EAF5F7] hover:bg-[#DDEFF4] transition-colors">
          {p.nome}{p.prezzo_adulti ? ` • ${fmtMoney(p.prezzo_adulti)}/pers.` : ""}
        </button>
      ))}
    </div>
  );
}

export const presetPatch = (p, d) => ({
  ...(p.portate || {}),
  ...(p.formula ? { a_formula: p.formula } : {}),
  ...(p.prezzo_adulti ? { prezzo_adulti: String(p.prezzo_adulti) } : {}),
  ...(p.prezzo_bambini ? { prezzo_bambini: String(p.prezzo_bambini) } : {}),
});
